function PlpNativeSkeletonGrid({
  number = 12,
  className = 'mb-6 grid grid-cols-2 -mr-px lg:mb-10 lg:grid-cols-4'
}) {
  return (
    <div className={className}>
      {[...Array(number)].map(() => (
        <PlpNativeSkeletonCard number={number} />
      ))}
    </div>
  )
}

function PlpNativeSkeletonCard({ number = 12 }) {
  return [...Array(number)].map(() => (
    <div className="border-r border-b border-neutral-900 animate-pulse">
      <div className="relative block aspect-4/5 w-full bg-skeleton" />
      <div className="flex flex-1 flex-col p-3 lg:p-5">
        <div className="mb-0.5 h-5 w-full bg-skeleton" />
        <div className="mb-3 h-5 w-full bg-skeleton" />
        <div className="h-10 w-full bg-skeleton" />
      </div>
    </div>
  ))
}

function PlpNativeSkeletonGridArticle({ number = 6 }) {
  return (
    <div className="mb-6 grid grid-cols-1 -mr-px lg:mb-10 lg:grid-cols-3">
      {[...Array(number)].map(() => (
        <div className="flex flex-col border-r border-b border-neutral-900 animate-pulse">
          <div className="aspect-4/3 w-full bg-skeleton" />
          <div className="pl-3 pt-4 pr-5 pb-5 lg:p-5">
            <div className="h-5 w-1/3 bg-skeleton" />
            <div className="h-5 w-2/3 mt-1.5 bg-skeleton" />
          </div>
        </div>
      ))}
    </div>
  )
}

function PlpNativeSkeletonGridPage({ number = 6 }) {
  return (
    <div className="mb-6 grid grid-cols-1 -mr-px px-5 pt-5 pb-8 lg:px-10 lg:pt-8 lg:mb-10">
      {[...Array(number)].map(() => (
        <div className="relative mb-5 flex flex-col overflow-hidden border-b border-solid border-neutral-900 pb-5 last:border-0 lg:mb-6 lg:pb-6 last:mb-0 last:pb-0">
          <div className="h-5 w-20 mb-2 bg-skeleton" />
          <div className="h-5 mb-3 max-w-[1000px] bg-skeleton" />
          <div className="h-5 w-10 bg-skeleton" />
        </div>
      ))}
    </div>
  )
}

export { PlpNativeSkeletonGrid, PlpNativeSkeletonCard, PlpNativeSkeletonGridArticle, PlpNativeSkeletonGridPage }
